export const useSxStyles = () => {
  return {
    hdWidth: {
      width: '150px',
      height: '44px',
      padding: '4px',
      fontSize: '14px',
      borderBottom: 'solid 1px #D6D6D6',
      fontWeight: 'bold',
      fontFamily: 'arial, helvetica, sans-serif',
      color: 'unset',
    },
    tdWidth: {
      width: '150px',
      height: '44px',
      padding: '4px',
      fontSize: '14px',
      borderBottom: 'dashed 1px #D6D6D6',
      whiteSpace: 'pre-line',
      fontFamily: 'arial, helvetica, sans-serif',
      color: 'unset',
    },
    first: {
      fontWeight: 'bold',
    },
  };
};
